import { ComposeViewState } from 'owa-mail-compose-store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'clearKeysOfInternetHeadersToBeRemoved',
    (viewState: ComposeViewState) => {
        viewState.keysOfInternetHeadersToBeRemoved = [];
    }
);
